import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { ApiModule } from '../api/api.module';
import { A48HelpersService } from './a48-helpers/a48-helpers.service';
import { ReportHelpersService } from './report-helpers/report-helpers.service';
import { Act48Service } from './a48.service';
import { AutoAssignmentService } from './auto-assignment.service';
import { BaseItemHelpersService } from './base-item-helpers/base-item-helpers.service';
import { ComplianceItemActionService } from './compliance-item-action.service';
import { ComplianceItemHelpersService } from './compliance-item-helpers/compliance-item-helpers.service';
import { ComplianceItemService } from './compliance-item.service';
import { ComplyMessageService } from './comply-message.service';
import { CplErrorMessageHelpersService } from './cpl-error-message-helper/cpl-error-message-helper.service';
import { EdlPubSubLogService } from './edl-pub-sub-log/edl-pub-sub-log.service';
import { FileService } from './file.service';
import { GroupService } from './group.service';
import { ItemPacketService } from './item-packet/item-packet.service';
import { MetricService } from './metric.service';
import { NoteService } from './note.service';
import { OnboardingService } from './onboarding/onboarding.service';
import { PagingHelpersService } from './paging-helpers/paging-helpers.service';
import { PortalHelpersService } from './portal-helpers/portal-helpers.service';
import { QuestionnaireService } from './questionnaire.service';
import { RegistrationService } from './registration.service';
import { RequestHelpersService } from './request-helpers/request-helpers.service';
import { RequestItemActionService } from './request-item-action.service';
import { RequestItemService } from './request-item.service';
import { RequestVerifyService } from './request-verify.service';
import { ResizeableService } from './resizeable.service';
import { RosterPreferenceService } from './roster-preference/roster-preference.service';
import { TagService } from './tag.service';
import { UserCycleService } from './user-cycle/user-cycle.service';
import { UserRequestService } from './user-request.service';
import { VerifyService } from './verify.service';
import { ViewService } from './view.service';
import { VolunteerReportService } from './volunteer/volunteer-report.service';
import { VolunteerReportHelperService } from './volunteer/volunteer-report-helper.service';
import { ReportsService } from './reports/reports.service';

@NgModule({
    imports: [
        ApiModule,
        CommonModule
    ],
    providers: [
        A48HelpersService,
        ReportHelpersService,
        Act48Service,
        AutoAssignmentService,
        BaseItemHelpersService,
        ComplianceItemActionService,
        ComplianceItemHelpersService,
        ComplianceItemService,
        ComplyMessageService,
        CookieService,
        CplErrorMessageHelpersService,
        EdlPubSubLogService,
        FileService,
        GroupService,
        ItemPacketService,
        MetricService,
        NoteService,
        OnboardingService,
        PagingHelpersService,
        PortalHelpersService,
        QuestionnaireService,
        RegistrationService,
        RequestHelpersService,
        RequestItemActionService,
        RequestItemService,
        RequestVerifyService,
        ReportsService,
        ResizeableService,
        RosterPreferenceService,
        TagService,
        UserCycleService,
        UserRequestService,
        VerifyService,
        ViewService,
        ItemPacketService,
        CplErrorMessageHelpersService,
        VolunteerReportHelperService,
        VolunteerReportService
    ]
})
export class ServiceModule { }